import { For, Show } from 'solid-js';
import { type ChatCardDto, ChatCardKind, ChatCardState } from '~/shared/api/generated';
import { formatKopecks } from '~/shared/lib/formatters';

const STATE_LABEL: Record<ChatCardState, string> = {
  [ChatCardState.LIVE]: 'Ждёт клиента',
  [ChatCardState.DONE]: 'Исполнена',
  [ChatCardState.EXPIRED]: 'Закрыта',
  [ChatCardState.GONE]: 'Больше не действует',
};

const KIND_STATE_LABEL: Partial<Record<ChatCardKind, Partial<Record<ChatCardState, string>>>> = {
  [ChatCardKind.PAYMENT_LINK]: {
    [ChatCardState.LIVE]: 'Ждёт оплаты',
    [ChatCardState.DONE]: 'Оплачено',
    [ChatCardState.EXPIRED]: 'Счёт закрыт',
  },
  [ChatCardKind.GAME_REMINDER]: {
    [ChatCardState.LIVE]: 'Игра впереди',
    [ChatCardState.EXPIRED]: 'Игра прошла',
    [ChatCardState.GONE]: 'Отменено',
  },
  [ChatCardKind.GAME_INVITE]: {
    [ChatCardState.LIVE]: 'Ждёт ответа',
    [ChatCardState.DONE]: 'Клиент в игре',
    [ChatCardState.EXPIRED]: 'Приглашение неактуально',
    [ChatCardState.GONE]: 'Игры больше нет',
  },
  [ChatCardKind.GAME_RESULT]: {
    [ChatCardState.LIVE]: 'Итог игры',
    [ChatCardState.GONE]: 'Итог больше не действует',
  },
  [ChatCardKind.WAITLIST_SEAT]: {
    [ChatCardState.LIVE]: 'Место предложено',
    [ChatCardState.DONE]: 'Клиент записан',
    [ChatCardState.EXPIRED]: 'Предложение закрыто',
  },
};

export const cardStateLabel = (card: Pick<ChatCardDto, 'kind' | 'state'>): string =>
  KIND_STATE_LABEL[card.kind]?.[card.state] ?? STATE_LABEL[card.state];

export const ChatCardBlock = (props: { card: ChatCardDto }) => (
  <div class="flex flex-col gap-1 min-w-[200px]" data-testid="chat-card">
    <span class="text-[13px] font-semibold">{props.card.title}</span>
    <For each={props.card.lines}>{(line) => <span class="text-[12px] opacity-80">{line}</span>}</For>
    <Show when={props.card.amountKopecks != null}>
      <span class="text-[15px] font-semibold tabular-nums">
        {formatKopecks(props.card.amountKopecks, { exact: true })}
      </span>
    </Show>
    <span class="text-[11px] opacity-70">{cardStateLabel(props.card)}</span>
  </div>
);
